import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import Link from 'brastrap/containers/link/LinkContainer';
import Bandeau from 'brastrap/common/bandeau/Bandeau';
import EditorialBlock from 'brastrap/editorial/editorial-block/EditorialBlock';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';
import { VACANCY_PATH_ROOT } from '../../../../shared/routes/JobVacancy';

const messages = defineMessages({
  currentVacancies: {
    id: 'jobs.current-vacancies',
    defaultMessage: 'Current vacancies',
  },
  workForUs: {
    id: 'jobs.work-for-us',
    defaultMessage: 'Careers at Bravissimo',
  },
  departments: { id: 'jobs.departments', defaultMessage: 'Departments' },
});

const JobsSectionPage = props => {
  const {
    intl: { formatMessage },
  } = props;

  const returnNav = {
    label: formatMessage(messages.workForUs),
    url: '../',
  };

  return (
    <div className="c-jobs-section-page">
      <Bandeau
        title={formatMessage(messages.currentVacancies)}
        returnNav={returnNav}
      />

      <div className="c-page__main">
        <div className="l-grid l-grid--reverse">
          <div className="l-grid__unit l-grid__unit--content">
            <div className="s-prose">
              <h2 className="u-heading">
                {formatMessage(messages.departments)}
              </h2>
              {props.departments.length > 0 &&
                props.departments.map((department, index) => (
                  <div key={index} className="c-jobs-section-page__department">
                    {index > 0 && <hr />}
                    <h3 className="c-jobs-section-page__name u-subtitle">
                      {department.name}
                    </h3>
                    <p className="c-jobs-section-page__description">
                      {department.description}
                    </p>
                    {department.vacancies && department.vacancies.length > 0 && (
                      <ul className="c-jobs-section-page__vacancies">
                        {department.vacancies.map((vacancy, vacancyIndex) => (
                          <li key={vacancyIndex}>
                            <Link
                              href={`/${VACANCY_PATH_ROOT}${vacancy.slug}/`}
                            >
                              {vacancy.title}
                            </Link>{' '}
                            <span className="caption">{vacancy.location}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div className="l-grid__unit l-grid__unit--aside">
            {props.sidebars.map((item, index) => (
              <EditorialBlock key={index} content={item} />
            ))}
          </div>
        </div>
      </div>

      {props.containers.length > 0 && (
        <EditorialContainer containers={props.containers} />
      )}
    </div>
  );
};

JobsSectionPage.propTypes = {
  departments: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      vacancies: PropTypes.arrayOf(
        PropTypes.shape({
          slug: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          location: PropTypes.string,
        })
      ),
    })
  ),
  sidebars: PropTypes.array,
  containers: PropTypes.array,
  intl: intlShape,
};

JobsSectionPage.defaultProps = {
  departments: [],
  sidebars: [],
  containers: [],
};

export default injectIntl(JobsSectionPage);
